import {z} from 'zod';

import {FinancialProductPreferenceCoordinatesSchema} from './FinancialProductPreferenceCoordinatesSchema';

/** Relevant fields are required; irrelevant fields are absent from each product branch. */
export const CompleteFinancialProductPreferenceCoordinatesSchema = z.discriminatedUnion(
  'productType',
  [
    FinancialProductPreferenceCoordinatesSchema.pick({
      productType: true,
      termMonths: true,
      downPaymentPercentage: true,
    }).extend({
      productType: z.literal('STANDARD'),
      termMonths: FinancialProductPreferenceCoordinatesSchema.shape.termMonths.unwrap(),
      downPaymentPercentage:
        FinancialProductPreferenceCoordinatesSchema.shape.downPaymentPercentage.unwrap(),
    }),
    FinancialProductPreferenceCoordinatesSchema.pick({
      productType: true,
      termMonths: true,
      downPaymentPercentage: true,
      balloonPaymentPercentage: true,
    }).extend({
      productType: z.literal('BALLOON'),
      termMonths: FinancialProductPreferenceCoordinatesSchema.shape.termMonths.unwrap(),
      downPaymentPercentage:
        FinancialProductPreferenceCoordinatesSchema.shape.downPaymentPercentage.unwrap(),
      balloonPaymentPercentage:
        FinancialProductPreferenceCoordinatesSchema.shape.balloonPaymentPercentage.unwrap(),
    }),
    FinancialProductPreferenceCoordinatesSchema.pick({
      productType: true,
      termMonths: true,
      leasingTargetGroup: true,
      annualMileage: true,
    }).extend({
      productType: z.literal('LEASING'),
      termMonths: FinancialProductPreferenceCoordinatesSchema.shape.termMonths.unwrap(),
      leasingTargetGroup:
        FinancialProductPreferenceCoordinatesSchema.shape.leasingTargetGroup.unwrap(),
      annualMileage: FinancialProductPreferenceCoordinatesSchema.shape.annualMileage.unwrap(),
    }),
  ]
);
export type CompleteFinancialProductPreferenceCoordinates = z.infer<
  typeof CompleteFinancialProductPreferenceCoordinatesSchema
>;
